"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var headerReset = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map(function (tag) {
  return "& ".concat(tag);
}).join(' ,');
var useStyles = function useStyles(_ref) {
  var position = _ref.position;
  return (0, _styles.makeStyles)(function (theme) {
    var topBottomMargin = 1;
    var leftRightMargin = 0;
    if (position.includes('left') || position.includes('right')) {
      topBottomMargin = 0;
      leftRightMargin = 1;
    }
    return {
      tooltip: _defineProperty({
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1.5, 2),
        margin: theme.spacing(topBottomMargin, leftRightMargin),
        maxWidth: theme.spacing(60),
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(20),
        borderRadius: '4px',
        backgroundColor: theme.palette.NEUTRAL900
      }, headerReset, {
        fontWeight: 700,
        fontSize: theme.typography.pxToRem(12)
      }),
      arrow: {
        color: theme.palette.NEUTRAL900
      },
      header: {
        fontWeight: 600,
        margin: theme.spacing(0, 0, 0.5, 0)
      },
      content: {
        display: 'box',
        boxOrient: 'vertical',
        lineClamp: 7,
        overflow: 'hidden',
        fontWeight: 400,
        margin: 0,
        color: theme.palette.NEUTRAL000,
        lineHeight: theme.typography.pxToRem(18),
        '& > :first-child': {
          marginTop: 0
        },
        '& > :last-child': {
          marginBottom: 0
        }
      },
      footer: {
        marginTop: theme.spacing(1),
        '& a': {
          fontWeight: 600,
          color: theme.palette.BLUE100,
          textDecoration: 'none'
        }
      }
    };
  })();
};
var _default = useStyles;
exports.default = _default;